(function () {
    var AUTHORS = [
        ['Joel L.', 'Nov 2025', '2025-11-09'],
        ['Priya S.', 'Jan 2026', '2026-01-14'],
        ['Alex R.', 'Feb 2026', '2026-02-03'],
        ['Sam T.', 'Mar 2026', '2026-03-18'],
        ['Morgan K.', 'Apr 2026', '2026-04-06'],
        ['Riley P.', 'May 2026', '2026-05-12']
    ];

    var COPY = [
        {
            title: 'Stays cold for hours',
            body: 'Lined our cooler for a full afternoon and drinks stayed chilled. The sheets flex well even straight from the freezer.'
        },
        {
            title: 'Perfect fit for shipping',
            body: 'Used these on a small parcel lane and they held temperature through transit. No leaks and easy to refreeze after delivery.'
        },
        {
            title: 'Great reusable option',
            body: 'We have run multiple cycles on the same sheets and the cells still feel evenly filled. Much better than single-use packs.'
        },
        {
            title: 'Flexible when frozen',
            body: 'Bends around bottles and box corners without cracking. Exactly what we needed for tight cooler layouts.'
        },
        {
            title: 'Easy pack-out',
            body: 'Freezes fast, lays flat in the shipper, and does not add awkward bulk. Setup is quick for repeat weekly runs.'
        },
        {
            title: 'Reliable cold mass',
            body: 'Solid cooling performance for meal-kit style shipments. Cells stayed evenly frozen and the sheet kept its shape.'
        }
    ];

    var PACKS = [
        {
            match: ['ice-pack', 'cooler', 'cooling-sheet', '12-x-17', '2-pack'],
            reviews: [
                {
                    title: 'Great for weekend coolers',
                    body: 'These large sheets cover the bottom of our cooler perfectly. Still flexible when frozen and easy to reposition around drinks.'
                },
                {
                    title: 'Solid two-pack value',
                    body: 'Having two sheets lets us rotate while one refreezes. Both held up well after several camping trips.'
                },
                {
                    title: 'Extra large size works',
                    body: 'The 12 x 17 size is exactly what we needed for bigger coolers. Freezes evenly and stays cold longer than disposables.'
                }
            ]
        },
        {
            match: ['premium', 'ice-blanket'],
            reviews: [
                {
                    title: 'Flagship quality',
                    body: 'Cell layout gives strong cold mass for sensitive shipments. Stays flexible from the freezer and refreezes cleanly.'
                },
                {
                    title: 'Pharma lane ready',
                    body: 'Swapped these in for gel packs on a meal-kit lane and temperature stayed stable through a full transit day.'
                }
            ]
        },
        {
            match: ['pro', 'flexible'],
            reviews: [
                {
                    title: 'Conforms to any pack-out',
                    body: 'Bends around insulated bag corners without cracking. Same trusted cell design as our other FluxCold sheets.'
                },
                {
                    title: 'Catering workhorse',
                    body: 'We use these for event coolers every week. They refreeze fast and the seams are still tight after heavy reuse.'
                },
                {
                    title: 'No awkward bulges',
                    body: 'Lays flat in parcel boxes and does not fight the lid like rigid packs. Makes tight layouts much easier.'
                }
            ]
        },
        {
            match: ['multi-pack', 'multipack'],
            reviews: [
                {
                    title: 'Good for teams that ship often',
                    body: 'Multi-sheet pack is handy for back-to-back pack-outs. Each sheet froze evenly and stored flat between runs.'
                },
                {
                    title: 'Handy variety',
                    body: 'Nice to have several sheets ready for different box sizes. All five-star performance so far across the pack.'
                }
            ]
        },
        {
            match: ['starter', 'cold-chain'],
            reviews: [
                {
                    title: 'Easy first setup',
                    body: 'Good starter set for our first cold shipments. Sizes matched common parcel footprints and setup was straightforward.'
                },
                {
                    title: 'Helpful for new shippers',
                    body: 'Gave our team a simple baseline for pack-outs. Sheets stayed cold through test runs before we went live.'
                },
                {
                    title: 'Worth the bundle',
                    body: 'Picked this up for a small catering side business. Everything arrived ready to freeze and performed as expected.'
                }
            ]
        }
    ];

    function hashString(str) {
        var h = 0;
        for (var i = 0; i < str.length; i++) {
            h = ((h << 5) - h) + str.charCodeAt(i);
            h |= 0;
        }
        return Math.abs(h);
    }

    function handleMatches(handle, terms) {
        var normalized = String(handle || '').toLowerCase();
        for (var i = 0; i < terms.length; i++) {
            if (normalized.indexOf(String(terms[i]).toLowerCase()) !== -1) {
                return true;
            }
        }
        return false;
    }

    function findPack(handle) {
        for (var i = 0; i < PACKS.length; i++) {
            if (handleMatches(handle, PACKS[i].match)) {
                return PACKS[i].reviews;
            }
        }
        return null;
    }

    function buildFallbackSeeds(handle, title) {
        var h = hashString(handle || title || 'product');
        var count = 2 + (h % 2);
        var seeds = [];
        var productLabel = title || 'this product';

        for (var i = 0; i < count; i++) {
            var author = AUTHORS[(h + i) % AUTHORS.length];
            var copy = COPY[(h + i * 2) % COPY.length];
            seeds.push({
                id: 'seed-' + handle + '-' + (i + 1),
                rating: 5,
                title: copy.title,
                body: copy.body.replace('these', productLabel).replace('These', productLabel),
                author: author[0],
                date: author[2],
                displayDate: author[1],
                verified: true,
                helpful: 1 + ((h + i) % 4)
            });
        }
        return seeds;
    }

    function normalizeSeed(handle, review, index) {
        var author = AUTHORS[index % AUTHORS.length];
        return {
            id: 'seed-' + handle + '-' + (index + 1),
            rating: 5,
            title: review.title,
            body: review.body,
            author: author[0],
            date: author[2],
            displayDate: author[1],
            verified: true,
            helpful: Math.max(1, 4 - index)
        };
    }

    window.FluxColdReviewSeeds = {
        get: function (handle, title) {
            var pack = findPack(handle);
            if (pack && pack.length) {
                return pack.map(function (review, index) {
                    return normalizeSeed(handle, review, index);
                });
            }
            return buildFallbackSeeds(handle, title);
        }
    };
})();
